import { atom } from "@byko/lib-recoil";

export const backdropBlurState = atom<boolean>({
  key: "use-backdrop-blur",
  default: true,
});
